import React, { useEffect, useState } from "react";
import { Table, Breadcrumb, Switch } from "antd";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useParams } from "react-router-dom";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../constant/reportType";
import {
    MINTING_TRANSACTION_COLUMN,
    CARBON_INVENTORY_COLUMN,
    CARBON_SALE_TRANSACTION_COLUMN,
    RETIREMENT_TRANSACTION_COLUMN,
} from "../constant/AppConstant";
import { BsPlus, BsSearch, BsPencilSquare, BsTrash } from "react-icons/bs";
import { alertMessage } from "../../utils/AlertService";
import Loading from "../Loading";
import { useAppDispatch, useAppSelector } from "../../redux-toolkit/hooks";
import { getLocalStorageData } from "../../utils/LocalStorageService";

import {
    useDeleteMintingTransactionMutation,
    useGetAllMintingTransactionMutation,
} from "../../redux-toolkit/services/mintingTransactionService";
import {
    useDeleteCarbonInventoryMutation,
    useGetAllCarbonInventoryMutation,
} from "../../redux-toolkit/services/carbonInventoryService";
import {
    useDeleteCarbonSaleTransactionMutation,
    useGetAllCarbonSaleTransactionMutation,
} from "../../redux-toolkit/services/carbonSaleTransactionService";
import {
    useDeleteRetirementTransactionMutation,
    useGetAllRetirementTransactionMutation,
} from "../../redux-toolkit/services/retirementTransactionService";

import {
    getAllMintingTransactionDetails,
    getMintingTransactionTotalRecords,
    setMintingTransaction,
} from "../../redux-toolkit/slices/mintingTransactionSlice";
import {
    getAllCarbonInventoryDetails,
    getCarbonInventoryTotalRecords,
    setCarbonInventory,
} from "../../redux-toolkit/slices/carbonInventorySlice";
import {
    getAllCarbonSaleTransactionDetails,
    getCarbonSaleTransactionTotalRecords,
    setCarbonSaleTransaction,
} from "../../redux-toolkit/slices/carbonSaleTransactionSlice";
import {
    getAllRetirementTransactionDetails,
    getRetirementTransactionTotalRecords,
    setRetirementTransaction,
} from "../../redux-toolkit/slices/retirementTransactionSlice";

import CarbonTransactionData from "./CarbonTransactionData";

const CarbonTransaction: React.FC = () => {
    const params = useParams();
    const localUserObj = getLocalStorageData("localUser");
    const dispatch = useAppDispatch();

    const [reportName, setReportName] = useState<string>("");
    const [actionType, setActionType] = useState<string>("");
    const [showData, setShowData] = useState<boolean>(false);
    const [columnData, setColumnData] = useState<any>([]);
    const [datasource, setDatasource] = useState<any>([]);
    const [rowData, setRowData] = useState<any>({});
    const [page, setPage] = useState<number>(1);
    const [size, setSize] = useState<number>(10);
    const [call, setCall] = useState<string>("N");
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any>(null);

    // list mutations
    const [getAllMintingTransaction, allMintingTransactionResponse] = useGetAllMintingTransactionMutation();
    const [getAllCarbonInventory, allCarbonInventoryResponse] = useGetAllCarbonInventoryMutation();
    const [getAllCarbonSaleTransaction, allCarbonSaleTransactionResponse] = useGetAllCarbonSaleTransactionMutation();
    const [getAllRetirementTransaction, allRetirementTransactionResponse] = useGetAllRetirementTransactionMutation();

    // delete mutations
    const [deleteMintingTransaction, deleteMintingTransactionResponse] = useDeleteMintingTransactionMutation();
    const [deleteCarbonInventory, deleteCarbonInventoryResponse] = useDeleteCarbonInventoryMutation();
    const [deleteCarbonSaleTransaction, deleteCarbonSaleTransactionResponse] = useDeleteCarbonSaleTransactionMutation();
    const [deleteRetirementTransaction, deleteRetirementTransactionResponse] = useDeleteRetirementTransactionMutation();

    // totalRecords
    const totalMintingTransaction: any = useAppSelector(getMintingTransactionTotalRecords);
    const totalCarbonInventory: any = useAppSelector(getCarbonInventoryTotalRecords);
    const totalCarbonSaleTransaction: any = useAppSelector(getCarbonSaleTransactionTotalRecords);
    const totalRetirementTransaction: any = useAppSelector(getRetirementTransactionTotalRecords);

    // selectors
    const allMintingTransaction: any = useAppSelector(getAllMintingTransactionDetails);
    const allCarbonInventory: any = useAppSelector(getAllCarbonInventoryDetails);
    const allCarbonSaleTransaction: any = useAppSelector(getAllCarbonSaleTransactionDetails);
    const allRetirementTransaction: any = useAppSelector(getAllRetirementTransactionDetails);

    useEffect(() => {
        setPage(1);
        switch (params.reportType) {
            case REPORT_PATH.MINTING_TRANSACTION:
                setReportName(REPORT_NAME.MINTING_TRANSACTION);
                break;
            case REPORT_PATH.CARBON_INVENTORY:
                setReportName(REPORT_NAME.CARBON_INVENTORY);
                break;
            case REPORT_PATH.CARBON_SALE_TRANSACTION:
                setReportName(REPORT_NAME.CARBON_SALE_TRANSACTION);
                break;
            case REPORT_PATH.RETIREMENT_TRANSACTION:
                setReportName(REPORT_NAME.RETIREMENT_TRANSACTION);
                break;
            default:
        }
    }, [params.reportType]);

    useEffect(() => {
        if (reportName) {
            fetchData();
        }
    }, [reportName, call]);

    useEffect(() => {
        const tempAction = {
            title: "ACTION",
            dataIndex: "action",
            key: "action",
            render: (text: string, record: any) => {
                return (
                    <div className="d-flex justify-content-between">
                        <div className="px-2 pe-auto">
                            <Switch
                                className={`${record.status === true ? "bg-accent" : "bg-secondry"}`}
                                checked={record.status === true}
                                onChange={() => {
                                    if (record.status === true) {
                                        setSelectedRecord(record);
                                        setShowDeleteModal(true);
                                    } else {
                                        onDeleteData(record, "activate");
                                    }
                                }}
                            />
                        </div>
                        {record.status === true ? (
                            <button className="btn p-0 px-2 pe-auto" title="Edit" onClick={() => { setRowData(record); setActionType(ACTION_TYPE.UPDATE_ACTION); setShowData(true); }}>
                                <BsPencilSquare className="text-accent cursor" size={18} />
                            </button>
                        ) : null}
                    </div>
                );
            },
        };
        const temp = [];

        if (reportName === REPORT_NAME.MINTING_TRANSACTION && MINTING_TRANSACTION_COLUMN) {
            MINTING_TRANSACTION_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.CARBON_INVENTORY && CARBON_INVENTORY_COLUMN) {
            CARBON_INVENTORY_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION && CARBON_SALE_TRANSACTION_COLUMN) {
            CARBON_SALE_TRANSACTION_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        } else if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION && RETIREMENT_TRANSACTION_COLUMN) {
            RETIREMENT_TRANSACTION_COLUMN.forEach((item: any) => temp.push(item));
            temp.push(tempAction);
            setColumnData(temp);
        }
    }, [reportName, params.reportType]);

    const fetchData = () => {
        if (reportName === REPORT_NAME.MINTING_TRANSACTION) {
            getAllMintingTransaction({ token: localUserObj?.token, payload: { pageNumber: page - 1, offset: size } });
        } else if (reportName === REPORT_NAME.CARBON_INVENTORY) {
            getAllCarbonInventory({ token: localUserObj?.token, payload: { pageNumber: page - 1, offset: size } });
        } else if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {
            getAllCarbonSaleTransaction({ token: localUserObj?.token, payload: { pageNumber: page - 1, offset: size } });
        } else if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {
            getAllRetirementTransaction({ token: localUserObj?.token, payload: { pageNumber: page - 1, offset: size } });
        }
    };

    const paginationChange = (pageNum: number, pageSize: number) => {
        setPage(pageNum);
        setSize(pageSize);
        if (reportName === REPORT_NAME.MINTING_TRANSACTION) {
            getAllMintingTransaction({ token: localUserObj?.token, payload: { pageNumber: pageNum - 1, offset: pageSize } });
        } else if (reportName === REPORT_NAME.CARBON_INVENTORY) {
            getAllCarbonInventory({ token: localUserObj?.token, payload: { pageNumber: pageNum - 1, offset: pageSize } });
        } else if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {
            getAllCarbonSaleTransaction({ token: localUserObj?.token, payload: { pageNumber: pageNum - 1, offset: pageSize } });
        } else if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {
            getAllRetirementTransaction({ token: localUserObj?.token, payload: { pageNumber: pageNum - 1, offset: pageSize } });
        }
    };

    const getRecordName = () => {
        if (reportName === REPORT_NAME.MINTING_TRANSACTION) return "Minting Transaction";
        if (reportName === REPORT_NAME.CARBON_INVENTORY) return "Carbon Inventory";
        if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) return "Carbon Sale Transaction";
        if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION) return "Retirement Transaction";
        return reportName;
    };

    const onDeleteData = (
        record: any,
        type: "soft" | "hard" | "activate"
    ) => {

        let mutationPromise: any;

        if (reportName === REPORT_NAME.MINTING_TRANSACTION) {
            mutationPromise = deleteMintingTransaction({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.CARBON_INVENTORY) {

            mutationPromise = deleteCarbonInventory({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) {

            mutationPromise = deleteCarbonSaleTransaction({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });

        } else if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION) {

            mutationPromise = deleteRetirementTransaction({
                token: localUserObj?.token,
                id: record.id,
                type: type,
            });
        }

        if (mutationPromise) {
            mutationPromise.unwrap()
                .then(() => {
                    const recName = getRecordName();
                    if (type === "hard") {
                        alertMessage(`${recName} deleted permanently`, "success");
                        setDatasource((prev: any) => prev.filter((item: any) => item.id !== record.id));
                    } else if (type === "soft") {

                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: false }
                                    : item
                            )
                        );

                        alertMessage(`${recName} deleted successfully`, "success");
                        setCall("Y");

                    } else if (type === "activate") {

                        setDatasource((prev: any) =>
                            prev.map((item: any) =>
                                item.id === record.id
                                    ? { ...item, status: true }
                                    : item
                            )
                        );

                        alertMessage(`${recName} activated successfully`, "success");
                        setCall("Y");
                    }
                })
                .catch((error: any) => {
                    const errorMsg = error?.data?.message || "Cannot delete this record because it is associated with other records";
                    alertMessage(errorMsg, "error");
                });
        }
    };

    const handleSoftDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "soft");
        }
    };

    const handleHardDelete = () => {
        setShowDeleteModal(false);
        if (selectedRecord) {
            onDeleteData(selectedRecord, "hard");
        }
    };

    // API responses
    useEffect(() => {
        if (allMintingTransactionResponse.isSuccess) dispatch(setMintingTransaction(allMintingTransactionResponse));
        else if (allMintingTransactionResponse.isError) alertMessage(allMintingTransactionResponse.error as any, "error");
    }, [allMintingTransactionResponse.isSuccess, allMintingTransactionResponse.isError]);

    useEffect(() => {
        if (allCarbonInventoryResponse.isSuccess) dispatch(setCarbonInventory(allCarbonInventoryResponse));
        else if (allCarbonInventoryResponse.isError) alertMessage(allCarbonInventoryResponse.error as any, "error");
    }, [allCarbonInventoryResponse.isSuccess, allCarbonInventoryResponse.isError]);

    useEffect(() => {
        if (allCarbonSaleTransactionResponse.isSuccess) dispatch(setCarbonSaleTransaction(allCarbonSaleTransactionResponse));
        else if (allCarbonSaleTransactionResponse.isError) alertMessage(allCarbonSaleTransactionResponse.error as any, "error");
    }, [allCarbonSaleTransactionResponse.isSuccess, allCarbonSaleTransactionResponse.isError]);

    useEffect(() => {
        if (allRetirementTransactionResponse.isSuccess) dispatch(setRetirementTransaction(allRetirementTransactionResponse));
        else if (allRetirementTransactionResponse.isError) alertMessage(allRetirementTransactionResponse.error as any, "error");
    }, [allRetirementTransactionResponse.isSuccess, allRetirementTransactionResponse.isError]);

    // DB mappings
    useEffect(() => { if (allMintingTransaction && reportName === REPORT_NAME.MINTING_TRANSACTION) setDatasource(Array.isArray(allMintingTransaction) ? allMintingTransaction : []); }, [allMintingTransaction]);
    useEffect(() => { if (allCarbonInventory && reportName === REPORT_NAME.CARBON_INVENTORY) setDatasource(Array.isArray(allCarbonInventory) ? allCarbonInventory : []); }, [allCarbonInventory]);
    useEffect(() => { if (allCarbonSaleTransaction && reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) setDatasource(Array.isArray(allCarbonSaleTransaction) ? allCarbonSaleTransaction : []); }, [allCarbonSaleTransaction]);
    useEffect(() => { if (allRetirementTransaction && reportName === REPORT_NAME.RETIREMENT_TRANSACTION) setDatasource(Array.isArray(allRetirementTransaction) ? allRetirementTransaction : []); }, [allRetirementTransaction]);

    const getTotalRecords = () => {
        if (reportName === REPORT_NAME.MINTING_TRANSACTION) return totalMintingTransaction;
        if (reportName === REPORT_NAME.CARBON_INVENTORY) return totalCarbonInventory;
        if (reportName === REPORT_NAME.CARBON_SALE_TRANSACTION) return totalCarbonSaleTransaction;
        if (reportName === REPORT_NAME.RETIREMENT_TRANSACTION) return totalRetirementTransaction;
        return 0;
    };

    const isLoading =
        deleteMintingTransactionResponse.isLoading ||
        deleteCarbonInventoryResponse.isLoading ||
        deleteCarbonSaleTransactionResponse.isLoading ||
        deleteRetirementTransactionResponse.isLoading ||
        allMintingTransactionResponse.isLoading ||
        allCarbonInventoryResponse.isLoading ||
        allCarbonSaleTransactionResponse.isLoading ||
        allRetirementTransactionResponse.isLoading;

    return (
        <div className="mt-2 overflow-y-auto">
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Body className="text-center pb-0 mt-3">
                    <h5 className="mb-4">Do you want to delete this record permanently?</h5>
                </Modal.Body>
                <Modal.Footer className="border-0 justify-content-center mb-2">
                    <Button variant="danger" onClick={handleHardDelete}>
                        Yes
                    </Button>
                    <Button variant="secondary" onClick={handleSoftDelete}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>

            {isLoading && <Loading />}
            <div className="d-flex align-items-center justify-content-between mx-3 px-1 my-3">
                <Breadcrumb className="fw-semibold font-10">
                    <Breadcrumb.Item className="text-secondary opacity-75">Transactions (Reports)</Breadcrumb.Item>
                    <Breadcrumb.Item className="text-dark">{reportName}</Breadcrumb.Item>
                </Breadcrumb>
                <div className="d-flex align-items-center">
                    <button className="btn bg-accent text-white font-10 mx-3 d-flex align-items-center rounded-2 fw-semibold px-3 py-2" onClick={() => { setRowData({}); setActionType(ACTION_TYPE.ADD_ACTION); setShowData(true); }}>
                        <span className="me-2 fw-bold"><BsPlus size={18} /></span>
                        Add {reportName}
                    </button>
                    <div className="d-flex font-10 align-items-center rounded-2 border py-1 bg-white">
                        <span className="ms-2 mt-1 px-1 ms-1 text-secondary"><BsSearch size={14} /></span>
                        <input type="text" className="form-control border-0 bg-transparent shadow-none" placeholder="Search Filter..." />
                    </div>
                </div>
            </div>

            <div className="mx-3 mt-4 px-1 pb-3 overflow-auto">
                <Table
                    columns={columnData}
                    dataSource={datasource}
                    scroll={{ x: '100%' }}
                    pagination={{
                        showSizeChanger: true,
                        total: getTotalRecords(),
                        pageSize: size,
                        current: page,
                        onChange: paginationChange,
                    }}
                />
            </div>
            {showData && (
                <CarbonTransactionData
                    show={showData}
                    setShow={setShowData}
                    actionType={actionType}
                    data={rowData}
                    reportName={reportName}
                    setCall={setCall}
                />
            )}
        </div>
    );
};

export default CarbonTransaction;
